import React from "react";
import { FiCheck, FiX } from "react-icons/fi";

const Published = (props) => {
  const style = { cursor: "pointer" };
  if (props.status) {
    return <FiCheck style={style} onClick={props.onClick} />;
  } else {
    return <FiX style={style} onClick={props.onClick} />;
  }
};

export default Published;
